<div class="row ">
  <div class="col-12">
    <app-icon-with-input [inputName]="'customerAddress1'"
      [inputType]="'text'" [inputId]="'customerAddress1'"
      (keydown.enter)="onKeydown($event, 'customerAddress2')"
      [inputValue]="customerDetails?.billingAddressModel?.addressLine1"
      (inputValueEmit)="customerDetails.billingAddressModel.addressLine1 = $event"
      [inputPlaceholder]="'Address 1'" [InputLabel]="'Address 1'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
</div>

<div class="row mt-2 ">
  <div class="col-12">
    <app-icon-with-input [inputName]="'customerAddress2'" 
      [inputType]="'text'" [inputId]="'customerAddress2'" 
      (keydown.enter)="onKeydown($event, 'billingAddressCountry')"
      [inputValue]="customerDetails?.billingAddressModel?.addressLine2"
      (inputValueEmit)="customerDetails.billingAddressModel.addressLine2 = $event" [inputPlaceholder]="'Address 2'"
      [InputLabel]="'Address 2'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12 d-flex">
    <div class="col-6 d-flex pe-1 country_dropdown_container">  
      <div class="d-flex align-items-center country_dropdown">
        <label class="text-nowrap mb-0">Country</label><span class="text-color-danger ms-1">*</span>
      </div>
      <div class="col ml-85">
        <app-custom-select2 
          #countryDropdown
          [customId]="'countryDropdown'"
          [dropdownMandatory]="true"
          [whichDropdown]="storageName?.COUNTRY_DROPDOWN"
          (valueChanged)="assignBillingCountryId($event)" 
          (keydown.enter)="onKeydown($event, 'billingAddressState')"
        >
        </app-custom-select2>
      </div>
    </div>
    <div class="col-6 d-flex ps-1 country_dropdown_container">  
      <div class="d-flex align-items-center country_dropdown">
        <label class="text-nowrap mb-0">State</label><span class="text-color-danger ms-1">*</span>
      </div>
      <div class="col ml-85">
        <app-custom-select2 
          #stateSelect  
          [customId]="'stateSelect'"
          [dropdownMandatory]="true"
          [whichDropdown]="storageName?.STATE_DROPDOWN"
          (valueChanged)="assignBillingStateId($event)" 
          (keydown.enter)="onKeydown($event, 'customerPinCode')"
        >
        </app-custom-select2>
      </div>
    </div>
  </div>
</div>

<div class="row mt-2">
  <div class="col-6 pe-1">
    <app-icon-with-input [inputName]="'customerPinCode'" [inputMaxlength]="9" [isOnlyAlphabetsAndNumbers]="true"
      [inputType]="'text'" [inputId]="'customerPinCode'"
      [inputValue]="customerDetails?.billingAddressModel?.pinCode"
      (keydown.enter)="onKeydown($event, '')" [isAllowDecimal]="false"
      (inputValueEmit)="customerDetails.billingAddressModel.pinCode = $event" [isRequired]="false"
      [inputPlaceholder]="'Zip Code'" [InputLabel]="'Zip Code'" labelName="true" [className]="'w-90px'"></app-icon-with-input>
  </div>
</div>

